import { useEffect, useState } from 'react'
import { MagnifyingGlass, Tag } from '@phosphor-icons/react'
import { DataTableEmptyState } from '../../../components/table/DataTable'
import UbiquaDataTable from '../../../components/table/UbiquaDataTable'
import UbiquaTablePagination from '../../../components/table/UbiquaTablePagination'
import FilterUbiquaMui from '../../../components/Filters/FilterUbiquaMui/FilterUbiquaMui'
import { reportUserColumns } from '../helpers/reportUserColumns'
import FilterUbiquaNotice from '../../../components/Filters/FilterUbiquaMui/FilterUbiquaNotice'
import {
  SETTLEMENT_STATUS_FILTER_OPTIONS,
  SETTLEMENT_STATUS_MULTI_DAY_NOTE
} from '../helpers/pendingSettlement'
import { downloadReportTable } from '../helpers/downloads/reportIndexDownloads'

export default function ReportUserTable({
  activeTab,
  data = [],
  loading = false,
  searchQuery,
  onSearchQuery,
  onRowClick,
  currentPage,
  totalPages,
  totalCount,
  perPage = 25,
  onPageChange,
  onRowsPerPageChange,
  startDate,
  endDate,
  pendingSettlementFilter,
  onPendingSettlementFilterChange,
  shouldShowReset,
  onResetFilters,
  isSingleDayRange = true,
  hasPendingSettlementQuery = ''
}) {
  const hasSettlementFilter = ['charges', 'deliveries'].includes(activeTab)
  const filters = hasSettlementFilter
    ? [
        {
          key: 'settlement_status',
          label: 'Estado de liquidación',
          icon: Tag,
          options: SETTLEMENT_STATUS_FILTER_OPTIONS,
          alwaysInline: true,
          showSearch: false,
          disabled: !isSingleDayRange,
          disabledReason: SETTLEMENT_STATUS_MULTI_DAY_NOTE
        }
      ]
    : []
  const [query, setQuery] = useState(searchQuery || '')
  useEffect(() => setQuery(searchQuery || ''), [searchQuery])
  const columns = reportUserColumns(activeTab, {
    multiDay: startDate !== endDate,
    isSingleDayRange,
    onOpenUser: onRowClick
  })
  return (
    <section
      className={`report-user-details${hasSettlementFilter ? ' report-user-details--settlement' : ' report-user-details--search-only'}`}
    >
      <div className="report-section-label">
        <strong>Detalles de reporte</strong>
        <span>Detalles de reporte por usuario</span>
      </div>
      <FilterUbiquaMui
        title="Buscar usuarios"
        filters={filters}
        appliedFilterSelections={{ settlement_status: pendingSettlementFilter }}
        onFilterChange={(_, selection) => onPendingSettlementFilterChange?.(selection)}
        autoApply
        showMoreFilters={false}
        headingTrailingContent={
          hasSettlementFilter && !isSingleDayRange ? (
            <FilterUbiquaNotice>{SETTLEMENT_STATUS_MULTI_DAY_NOTE}</FilterUbiquaNotice>
          ) : null
        }
        searchInput={query}
        appliedSearchInput={searchQuery}
        onSearchChange={(event) => setQuery(event.target.value)}
        onSearchEnter={(event) => {
          if (event.key === 'Enter') onSearchQuery(query.trim())
        }}
        onSearchClear={() => {
          setQuery('')
          onSearchQuery('')
        }}
        searchPlaceholder="Buscar usuario por código o nombre..."
        onExport={() =>
          downloadReportTable({
            activeTab,
            startDate,
            endDate,
            searchQuery,
            hasPendingSettlementQuery
          })
        }
        onResetFilters={onResetFilters}
        isAnyFilterSelected={shouldShowReset}
        showResetFilters={Boolean(onResetFilters)}
      />
      <UbiquaDataTable
        className="report-user-table"
        ariaLabel="Reporte de usuarios"
        columns={columns}
        rows={data}
        loading={loading}
        rowKey="user_uid"
        minWidth={columns.reduce((width, column) => width + column.width, 0)}
        emptyContent={
          <DataTableEmptyState
            icon={<MagnifyingGlass size={34} aria-hidden="true" />}
            title="No encontramos usuarios"
            description="Revisa el código o el nombre e intenta de nuevo."
          />
        }
        onRowClick={(row) => onRowClick({ preventDefault() {} }, row.user_uid)}
      />
      {data.length > 0 ? (
        <UbiquaTablePagination
          disabled={loading}
          pagination={{
            total_count: totalCount ?? data.length,
            per_page: perPage,
            current_page: currentPage,
            total_pages: totalPages
          }}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      ) : null}
    </section>
  )
}
